import type { ComponentProps } from 'react';
import { OwcSelectDropdown } from '@one/react';

export type PocSelectDropdownProps = ComponentProps<typeof OwcSelectDropdown>;

export const PocSelectDropdown: React.FC<PocSelectDropdownProps> = (props) => <OwcSelectDropdown {...props} />;
